import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import AuditReport from '../components/shared/AuditReport'

export default function Reports() {
  return (
    <Container fluid className="mt-20">
      <Row>
        <Col md="12">
          <h1>Reports</h1>
          <AuditReport />
        </Col>
      </Row>
    </Container>
  )
}
